<script>
// import jQuery from 'jquery'
window.$ = window.jQuery = require('jquery');

import '../slick'
import '../slick_lightbox'


import p1_img1 from '../assets/p-imgs/p1/p1_img1.jpg';
import p1_img2 from '../assets/p-imgs/p1/p1_img2.jpg';
import p1_img3 from '../assets/p-imgs/p1/p1_img3.jpg';
import p1_img4 from '../assets/p-imgs/p1/p1_img4.jpg';
import p1_img5 from '../assets/p-imgs/p1/p1_img5.jpg';

import p2_img1 from '../assets/p-imgs/p2/p2_img1.jpg';
import p2_img2 from '../assets/p-imgs/p2/p2_img2.jpg';


import p3_img1 from '../assets/p-imgs/p3/p3_img1.jpg';
import p3_img2 from '../assets/p-imgs/p3/p3_img2.jpg';

import p4_img1 from '../assets/p-imgs/p4/p4_img1.jpg';
import p4_img2 from '../assets/p-imgs/p4/p4_img2.jpg';

import p5_img1 from '../assets/p-imgs/p5/p5_img1.jpg';
import p5_img2 from '../assets/p-imgs/p5/p5_img2.jpg';

import p6_img1 from '../assets/p-imgs/p6/p6_img1.jpg';
import p6_img2 from '../assets/p-imgs/p6/p6_img2.jpg';

import p7_img1 from '../assets/p-imgs/p7/p7_img1.jpg';
import p7_img2 from '../assets/p-imgs/p7/p7_img2.jpg';

import p8_img1 from '../assets/p-imgs/p8/p8_img1.jpg';
import p8_img2 from '../assets/p-imgs/p8/p8_img2.jpg';

import PageHeader from '../subview/PageHeader.vue';


// import aw1 from '../assets/logo-da.svg';
// import aw2 from '../assets/logo-gda.svg';



// import share2Src from '../assets/share-02.svg';

export default {
    components: {
        PageHeader
    },
    data(){
        return {
            isProduct: false,
            s_logo_svg: `<svg version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 132.5 80.4" style="enable-background:new 0 0 132.5 80.4;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#14227F;}
	.st1{fill:#FFFFFF;}
</style>
<path class="st0" d="M127.5,80.4H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h122.5c2.7,0,5,2.2,5,5v70.4
	C132.5,78.1,130.3,80.4,127.5,80.4z"/>
<g>
	<path class="st1" d="M78.6,34.2L66.3,50.7L54,34.2l-6.6,5.2c0,0,13,17.2,15.4,20.1c1,1.2,2.2,1.8,3.5,1.8c1.3,0,2.5-0.6,3.5-1.8
		c2.4-2.9,15.4-20.1,15.4-20.1L78.6,34.2z"/>
	<path class="st1" d="M66.3,21.5l26.2,39.9l6.1-6.7L69.7,11.9c-0.8-1.1-2.1-1.8-3.4-1.8c-1.4,0-2.6,0.7-3.4,1.8L34,54.7l6.1,6.7
		L66.3,21.5z"/>
	<path class="st1" d="M66.3,8.7c-21.8,0-39.4,14.1-39.4,31.5c0,17.4,17.6,31.5,39.4,31.5c21.8,0,39.4-14.1,39.4-31.5
		C105.7,22.8,88,8.7,66.3,8.7 M66.3,67.8c-19.1,0-34.7-12.4-34.7-27.6c0-15.2,15.6-27.6,34.7-27.6c19.1,0,34.7,12.4,34.7,27.6
		C100.9,55.4,85.4,67.8,66.3,67.8"/>
</g>
</svg>`,
            all_ps: [
                {
                    pd_id: "pd00",
                    name: "日安生活馬克杯",
                    brand_imgs: 0,
                    text1: "<span>40</span>枚＋$99",
                    text2: "<span>20</span>枚＋$199",
                    bluetext: "或扣1000點福利點 <span>$199馬上換<small> (限量6,000組)</small></span>",
                    price_text: "參考市價$640",
                    des: "400ml容量恰好是一杯咖啡或熱茶的份量，想在辦公室來碗熱湯也能派上用場。<div>容量：400ml；共4色(綠/黃/紫/紅)，隨機出貨，恕無法挑選</div>",
                    imgs: [ 
                        {url: p1_img1, is_video: 0}, 
                        {url: p1_img2, is_video: 0},
                        {url: p1_img3, is_video: 0},
                        {url: p1_img4, is_video: 0},
                        {url: p1_img5, is_video: 0}
                    ],
                    links: [ p1_img1, p1_img2, p1_img3, p1_img4, p1_img5]
                },
                {
                    pd_id: "pd01",
                    name: "萬用深盤2入組",
                    brand_imgs: 0,
                    text1: "<span>40</span>枚＋$499",
                    text2: "<span>20</span>枚＋$599",
                    bluetext: "扣1000點福利點 <span>$599馬上換<small> (限量4,000組)</small></span>",
                    price_text: "參考市價$1,960",
                    des: "尺寸適中的萬用深盤，從蛋炒飯、PASTA或咖哩，盛裝多料或富含醬汁、湯水的餐食，都少不了它！<div>尺寸：22cm</div>",
                    imgs: [ 
                        {url: p2_img1, is_video: 0}, 
                        {url: p2_img2, is_video: 0},
                    ],
                    links: [p2_img1, p2_img2]
                },
                {
                    pd_id: "pd02",
                    name: "碗盤4件組",
                    brand_imgs: 0,
                    text1: "<span>50</span>枚＋$599",
                    text2: "<span>20</span>枚＋$799",
                    bluetext: "或扣1000點福利點 <span>$799馬上換<small> (限量2,000組)</small></span>",
                    price_text: "參考市價$2,320",
                    des: "無論中式小菜或者西式點心，使用頻率最高的平盤搭配輕巧小碗，滿足每一只貪吃的嘴。<div>尺寸：盤16cm、碗11cm</div>",
                    imgs: [ 
                        {url: p3_img1, is_video: 0}, 
                        {url: p3_img2, is_video: 0},
                       
                    ],
                    links: [ p3_img1, p3_img2]
                },
                {
                    pd_id: "pd03",
                    name: "獨享確幸4件組",
                    brand_imgs: 0,
                    text1: "<span>50</span>枚＋$699",
                    text2: "<span>20</span>枚＋$899",
                    bluetext: "或扣1000點福利點 <span>$899馬上換<small> (限量2,000組)</small></span>",
                    price_text: "參考市價$2,790",
                    des: "清爽淡雅的水藍釉色，搭配簡約大氣造型，給人一股寧靜優雅的感受，不僅適合獨處享用，也適合與其他餐瓷搭配。<div>尺寸：平盤28cm & 23cm、碗15cm</div><div>馬克杯容量：400ml</div>",
                    imgs: [ 
                        {url: p4_img1, is_video: 0},
                        {url: p4_img2, is_video: 0}
                       
                    ],
                    links: [ p4_img1, p4_img2]
                },
                {
                    pd_id: "pd04",
                    name: "和風方盤4件套組",
                    brand_imgs: 0,
                    text1: "<span>50</span>枚＋$799",
                    text2: "<span>20</span>枚＋$999",
                    bluetext: "或扣1000點福利點 <span>$999馬上換<small> (限量1,500組)</small></span>",
                    price_text: "參考市價$3,120",
                    des: "日式風格的方型平盤，最適合盛裝異國小食，從日本料理擺盤，到派對點心、特製醬料，俐落地拼湊出獨特的餐桌風格。<div>尺寸：長方盤23.5cm、方盤12cm</div>",
                    imgs: [ 
                        {url: p5_img1, is_video: 0}, 
                        {url: p5_img2, is_video: 0}
                        
                    ],
                    links: [ p5_img1, p5_img2]
                    //"https://www.youtube.com/embed/T7lHDVo9P3U?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1"
                },
                {
                    pd_id: "pd05",
                    name: "多功能餐碗8件組",
                    brand_imgs: 0,
                    text1: "<span>70</span>枚＋$1,499",
                    text2: "<span>20</span>枚＋$1,899",
                    bluetext: "或扣1,000點福利點 <span>$1,899馬上換<small> (限量1,500組)</small></span>",
                    price_text: "參考市價$5,700",
                    des: "來自俄羅斯娃娃的靈感，餐碗由小至大輕鬆堆疊收納，節省空間。從食材準備到餐食料理擺盤，滿足家庭多元料理需求。<div>尺寸：八件各為6/8.5/11/13.5/15.7/18/20/23.7cm</div>",
                    imgs: [ 
                        {url: p6_img1, is_video: 0},
                        {url: p6_img2, is_video: 0},
                       

                    ],
                    links: [p6_img1, p6_img2]
                },
                {
                    pd_id: "pd06",
                    name: "英倫午茶輕食8件組",
                    brand_imgs: 0,
                    text1: "<span>70</span>枚＋$1,599",
                    text2: "<span>20</span>枚＋$1,999",
                    bluetext: "或扣1,000點福利點 <span>$1,999馬上換<small> (限量1,000組)</small></span>",
                    price_text: "參考市價$5,880",
                    des: "沖一杯醇厚的espresso，拿取雙耳盤內的手作輕食，再嚐一口長方盤上的糕點，如享受泰晤士河畔的清新微風一樣幸福。<div>尺寸：長方盤20cm*13.5cm、雙耳盤16cm、小碟11cm、咖啡杯容量90ml</div>",
                    imgs: [ 
                        {url: p7_img1, is_video: 0}, 
                        {url: p7_img2, is_video: 0}, 
                        
                    ],
                    links: [ p7_img1, p7_img2]
                },
                {
                    pd_id: "pd07",
                    name: "恆采家庭分享16件式餐具組",
                    brand_imgs: 0,
                    text1: "<span>70</span>枚＋$2,699",
                    text2: "<span>20</span>枚＋$3,299",
                    bluetext: "或扣1,000點福利點 <span>$3,299馬上換<small> (限量500組)</small></span>",
                    price_text: "參考市價$11,160",
                    des: "面面俱到的全套實用器皿，正是招待賓客的秘密武器，更是風格派對的理想道具。質感湖綠用來混搭1815全系列的多彩餐瓷，都能完美配適。<div>尺寸：平盤28cm & 23cm、碗15cm、馬克杯400ml</div>",
                    imgs:[
                        {url: p8_img1, is_video: 0},
                        {url: p8_img2, is_video: 0}
                    ],
                    links: [p8_img1,p8_img2 ]
                }
                
            ]
        }
    },
    props: ['id'],
    methods: {
        play(video){
            $('#'+video)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        },
        pause(){
            let video_count = $(".product-intro iframe").length;

            for(let i=0;i<video_count;i++){
                $('.yt-video')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
        },
        reg(str){
            return (str.match(/embed/)!==null)?0:1;
        },


        slider_nav($nav, $for){
            $($nav).slick({
                slidesToShow: 5,
                //slidesToScroll: 1,
                asNavFor: $for,
                //infinite: false,
                //dots: true,
                //centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        },
        slider_for($nav, $for){
            $($for).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: $nav
            });
        },
        light_box($for){
            $($for).slickLightbox({
                itemSelector        : 'a',
                navigateByKeyboard  : true
            });

        },
        after_change($for){
            $($for).on('afterChange', (event, slick, cur)=>{
                //alert( $(slick.$slides[cur]).find('iframe').attr('id') );
                this.pause();
                let type = $(slick.$slides[cur]).find('iframe').data('type');
                let id = $(slick.$slides[cur]).find('iframe').attr('id');
                //console.log(type+id)
                
                if(type==="video"){
                    this.play(id);
                    setTimeout(()=>{
                        this.play(id);
                    },100)
                    // setTimeout(()=>{
                    //     this.play(id);
                    // },200)
                    // setTimeout(()=>{
                    //     this.play(id);
                    // },300)
                    // setTimeout(()=>{
                    //     this.play(id);
                    // },400)
                    // setTimeout(()=>{
                    //     this.play(id);
                    // },500)
                    // setTimeout(()=>{
                    //     this.play(id);
                    // },600)

                }
            });
        },
        run_all_slide($nav, $for){
            this.slider_nav($nav, $for);
            this.slider_for($nav, $for);
            this.light_box($for);
            this.after_change($for);
        },
        filter(array){
            let pds = [];

            if(this.id === undefined){
                return array;
            }else{
                pds.push(array[this.id]);
                return pds;
            }
            //return (this.id === undefined)?array:pds;
        },
        ga_func(class_name, name){
            $(class_name).on('click', function (e) {
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        },
		pd_fb_share(id, pd_id){

            //console.log(this.$route.name);
            // console.log(pd_id);

            var o_s = window.location.href;

            var hash_p = o_s.indexOf("#");
            console.log(hash_p);
            var n_s = o_s.slice(0, hash_p+2);
            //console.log(n_s);
            var s = n_s.replace('#', '?pd_id='+pd_id+'#');
            //var s = window.location.href;
            //console.log(s);
            if(this.$route.name=='product'){
                window.open('http://www.facebook.com/share.php?u=' + encodeURIComponent(o_s));
            }else{
                window.open('http://www.facebook.com/share.php?u=' + encodeURIComponent(s) + 'product/' + id);
            }

            
		},
		pd_line_share(id, pd_id){
            //e.preventDefault();
            console.log(pd_id);
            //var path = "http://test.moveon-design.com/pxmart-event/#/";
            var o_s = window.location.href;
            console.log('o_s',o_s);
            var hash_p = o_s.indexOf("#");
            console.log(hash_p);
            var n_s = o_s.slice(0, hash_p+2);
            console.log(n_s);
            var s = n_s.replace('#', '?pd_id='+pd_id+'&t=1'+"#");
            
            // var x = this.href.substr(this.href.lastIndexOf('/') + 1);
            // var i = s.indexOf(x);

            // s = s.substring(0, i);
            
            if(this.$route.name=='product'){
                window.open('https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(o_s));
                // window.open('https://social-plugins.line.me/lineit/share?url=' + o_s);

            }else{
                // var link = `https://social-plugins.line.me/lineit/share?url=${s}product/${id}`;
                var link = 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(s) + 'product/' + id;

                window.open(link);
            }
			// $(".allshare-line-btn").on("click", function (e) {
				
			// });
		}
    },
    
    computed: {
        product_class(){
            return (this.$route.name != 'product')?'product-intro':'product-intro product-inner';
        },
        is_product(){
            return (this.$route.name == 'product')?true:false;
        }
    },
    mounted(){
        let p_count = this.all_ps.length;
        for(let i=0;i<p_count;i++){
            this.run_all_slide(`.slider-nav${i+1}`,`.slider-for${i+1}`);
        }

        if(this.$route.name == 'product-intro'){
            setTimeout(()=>{
                $("HTML, BODY").animate({ scrollTop: $("#product-intro").offset().top }, 500);
                
            },500);
            
        }

        this.all_ps.forEach((el, i)=>{
            this.ga_func(".line_"+el.pd_id ,(el.name.replace(/<[^>]*>?/gm, ''))+"-line分享");
            this.ga_func(".fb_"+el.pd_id ,(el.name.replace(/<[^>]*>?/gm, ''))+"-fb分享");
            //console.log(el.name)
            this.ga_func(".slider-for"+(i+1) ,(el.name.replace(/<[^>]*>?/gm, ''))+"-觀看照片");

        });




        if(this.$route.name === "product"){

            this.isProduct = true
			// $("#product-intro").css({
			// 	"margin-bottom": 0,
			// 	"margin-top": "90px"
            // });

            $("#product-intro .bg").addClass("inner-bg");

		}
        console.log("pdIntro!!")


        let url = window.location.href;
        let n_url = url.replace("og_id", "pd_id");
        //window.location.href = n_url;
        //console.log(n_url);
        window.history.replaceState("test","test", n_url);
       
    },
    created(){
        
    }
}

</script>

<template>
    <div>
        <PageHeader v-if="isProduct" />
        <section :class="product_class" id="product-intro">
            <div class="bg"></div>
            <div class="container pd-container">
                <div class="row">
                    <div class="col-12">
                        <div class="title-wrap">
                            <h1 class="title">商品介紹</h1>
                        </div>
                    </div>
                </div>

                <div class="row pd-row" v-if="!is_product">
                    <div class="col-12 col-lg-6" v-for="(pd, index) in filter(all_ps)">
                        <div class="content-wrap-outer">
                            <div class="content-wrap">
                                <div>
                                <div class="title-wrapper">
                                    <h1 class="p-name" v-html="pd.name"></h1>
                                </div>
                                <div class="slider-for-outer">
                                    <div :class="`slider-for slider-for${index+1}`">
                                        <div class="img-wrap" v-for="(img, id) in pd.links">
                                            <template v-if="reg(img)">
                                                <a :href="img">
                                                    <img :src="img" alt="">
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a :href="img" class="video-class">
                                                    <div class="video-wrap">
                                                        <iframe 
                                                            class="yt-video" 
                                                            data-type="video" 
                                                            :id="`video${index*index*id}`" 
                                                            :src=img 
                                                            frameborder="0" 
                                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                                            allowfullscreen>
                                                        </iframe>
                                                    </div>
                                                </a>
                                            </template>
                                        </div>
                                    </div>           
                                </div>
                                <div class="photo-slide">
                                    <div :class="`slider-nav slider-nav${index+1}`">
                                        <div class="img-wrap" v-for="img in pd.imgs">
                                            <img :src="img.url" alt="">
                                            <img class="play-btn" v-if="img.is_video" src="../assets/play-btn.png" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="line1">
                                    <div class="text1" v-html="pd.text1"></div>
                                    <div class="text2" v-html="pd.text2"></div>
                                    <p class="price-text" v-html="pd.price_text"></p>
                                </div>
                                <div class="line2" v-if="pd.bluetext">
                                    <div class="s-logo" v-html="s_logo_svg"></div>
                                    <span v-html="pd.bluetext"></span>
                                </div>
                                
                                <p class="p-content" v-html="pd.des">
                                </p>
                                </div>
                                <div class="share-links">
                                    <a href="" :class="`line_${pd.pd_id}`" @click.prevent="pd_line_share(index, pd.pd_id)">
                                        <img src="../assets/share-01.svg" alt="">
                                    </a>                               
                                    <a href="" :class="`fb_${pd.pd_id}`" @click.prevent="pd_fb_share(index, pd.pd_id)">
                                        <img src="../assets/share-02.svg" alt="">
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row pd-row" v-for="(pd, index) in filter(all_ps)" v-else>
                    
                    <!-- <h1 class="p-name" v-html="pd.name"></h1> -->
                    
                    <div class="col-12 col-lg-6 order-lg-6">
                        <div class="content-wrap-outer">
                            <div class="content-wrap">
                                <div class="title-wrapper">
                                    <h1 class="p-name" v-html="pd.name"></h1>
                                </div>

                                <!-- <div class="award-line" v-if="pd.brand_imgs">
                                    <div class="aw2" v-if="pd.brand_imgs[1]">
                                        <img :src="pd.brand_imgs[1]" alt="">
                                    </div>
                                    <div class="aw1" v-if="pd.brand_imgs[0]">
                                        <img :src="pd.brand_imgs[0]" alt="">
                                    </div>
                                </div> -->
                                <div class="line1">
                                    <div class="text1" v-html="pd.text1"></div>
                                    <div class="text2" v-html="pd.text2"></div>
                                </div>
                                <div class="line2" v-if="pd.bluetext">
                                    <div class="s-logo" v-html="s_logo_svg"></div>
                                    <span v-html="pd.bluetext"></span>
                                </div>
                                <p class="price-text" v-html="pd.price_text"></p>
                                <p class="p-content" v-html="pd.des">
                                </p>
                                <div class="share-links">
                                    <a href="" :class="`line_${pd.pd_id}`" @click.prevent="pd_line_share(index, pd.pd_id)">
                                        <img src="../assets/share-01.svg" alt="">
                                    </a>
                                    
                                    <a href="" :class="`fb_${pd.pd_id}`" @click.prevent="pd_fb_share(index, pd.pd_id)">
                                        <img src="../assets/share-02.svg" alt="">
                                    </a>
                                </div>
                                <div class="photo-slide">
                                    <div :class="`slider-nav slider-nav${index+1}`">
                                        <div class="img-wrap" v-for="img in pd.imgs">
                                            <img :src="img.url" alt="">
                                            
                                            <img class="play-btn" v-if="img.is_video" src="../assets/play-btn.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="slider-for-outer">
                            <div :class="`slider-for slider-for${index+1}`">
                                <div class="img-wrap" v-for="(img, id) in pd.links">
                                    <template v-if="reg(img)">
                                        <a :href="img">
                                            <img :src="img" alt="">
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a :href="img" class="video-class">
                                            <div class="video-wrap">
                                                <iframe 
                                                    class="yt-video" 
                                                    data-type="video" 
                                                    :id="`video${index*index*id}`" 
                                                    :src=img 
                                                    frameborder="0" 
                                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                                    allowfullscreen>
                                                </iframe>
                                            </div>
                                        </a>
                                    </template>
                                </div>
                            </div>
                            
                            
                
                        </div>
                        <div class="share-links-m">
                            <a href="" class="line" @click.prevent="pd_line_share(index, pd.pd_id)">
                                <img src="../assets/share-01.svg" alt="">
                            </a>
                            
                            
                            <a href="" class="fb" @click.prevent="pd_fb_share(index, pd.pd_id)">
                                <img src="../assets/share-02.svg" alt="">
                            </a>
                            
                        </div>
                    </div>
                </div>

            </div>
        </section>

    </div>
    
</template>


<style lang="sass">
@import '../sass/global'

//$yellow: #ce1d1b
*
    //border: 1px solid
button.slick-arrow
    z-index: 100



    
.product-intro
    margin-top: 100px
    @media (max-width: 576px)
        margin-top: 0
    .bg
        background-image: url('../assets/product-bg.jpg')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center center
        transform: translateZ(0)
        will-change: transform
        z-index: -1001
    
    .inner-bg
        // background-image: url('../assets/index-bg.jpg') !important
        
    
    .pd-container
        position: relative
        @media (max-width: 991px)
            // padding-left: 50px
            // padding-right: 50px
        @media (max-width: 450px)
            padding-left: 15px
            padding-right: 15px
        &:before
            content: ''
            position: absolute
            //display: none
            width: 100%
            height: 100%
            top: 0
            left: 0
            background: white
            //box-shadow: 0 1px 10px rgba(black, 0.1)
            border-radius: 20px 20px 0 0
            //opacity: 0.65
            @media (max-width: 991px)
                display: block
                box-shadow: 0 1px 10px rgba(black, 0.1)
                opacity: 1

    .title-wrap
        text-align: center
        padding-top: 60px
        padding-bottom: 60px
        background: $green
        color: white
        margin-left: -15px
        margin-right: -15px
        font-weight: 300
        padding: 25px 0
        border-radius: 20px 20px 0 0
        @media (max-width: 991px)
            padding: 25px 0
        @media (max-width: 576px)
            padding: 25px 0
            border-radius: 0
        h1
            text-align: center
            font-weight: 400
            margin-bottom: 0
            letter-spacing: 2px
            font-size: 30px
    

    .pd-row
        margin-top: 80px
        position: relative
        margin-right: -10px
        margin-left: -10px
        padding-left: 5px
        padding-right: 5px
        background: white
        padding-bottom: 40px
        .col-12.col-lg-6
            padding-right: 10px
            padding-left: 10px
            margin-bottom: 50px
        @media (max-width: 991px)
            margin-top: 50px
            padding-bottom: 0px

    .content-wrap-outer
        
        display: flex
        align-items: flex-start
        justify-content: center
        border: 1px solid rgba(black, 0.3)
        height: 100%
        padding: 0 20px
        @media (max-width: 576px)
            padding: 0 15px
        .content-wrap
            height: 100%
            width: 100%
            display: flex
            flex-direction: column
            justify-content: space-between
            
            @media (max-width: 991px)
                font-size: 18px
            @media (max-width: 768px)
                font-size: 16px
                
            .logo-wrap
                margin-bottom: 10px
                img
                    width: 30%
                    min-width: 150px
                @media (max-width: 991px)
                    text-align: left
            .share-links
                a
                    display: inline-block
                    width: 80px
                    img
                        width: 100%
            .title-wrapper
                text-align: center
            .p-name
                font-size: 25px
                padding: 0 30px
                transform: translateY(-50%)
                background: white
                text-align: center
                display: inline-block
                margin: 0 auto
                position: relative
                letter-spacing: 1px
                @media (max-width: 576px)
                    width: 90%
                @media (max-width: 340px)
                    width: 95%
                span
                    font-size: 18px
                    display: block
                    position: absolute
                    left: 50%
                    transform: translate(-50%)
                    width: 100%

            .line1
                margin-bottom: 20px
                display: flex
                align-items: center
                @media (max-width: 1199px)
                    flex-wrap: wrap
                div
                    display: inline-block
                    white-space: nowrap
                    span
                        padding: 8px 10px
                        display: inline-block
                        background: black
                        border-radius: 5px
                        margin-right: 5px
                        color: white
                        @media (max-width: 576px)
                            padding: 6px 8px
                

                .text1
                    margin-right: 20px
                    @media (max-width: 576px)
                        margin-right: 5px
                .text1,.text2
                    cursor: pointer
                    transition: .3s
                    span
                        font-size: 18px
                    @media (max-width: 350px)
                        font-size: 14px
                        letter-spacing: 0px
                    &:hover
                        color: $darkGreen  
                        span
                            transition: .3s
                            background: $darkGreen 
                .price-text
                    text-align: right
                    width: 100%
                    margin-bottom: 0
                    color: rgba(black, 0.8)
                    @media (max-width: 1199px)
                        margin-top: 20px
                        text-align: left
                
            .line2
                color: #0f2a85
                margin-bottom: 10px
                display: flex
                //justify-content: center
                letter-spacing: 2px
                align-items: center
                @media (max-width: 991px)
                    span > span 
                        display: block
                .s-logo
                    display: inline-block
                    //width: 40px
                    vertical-align: middle
                    display: flex
                    align-items: center
                    justify-content: center
                    margin-right: 5px
                    width: 12%
                    max-width: 40px
                    @media (max-width: 576px)
                        height: 40px
                        min-width: 40px
                        position: relative
                    svg
                        width: 100%
                span
                    display: inline-block
                small
                    display: inline-block
                        //width: 
            .award-line
                margin-bottom: 15px
                .aw1
                    img
                        width: 150px
                .aw2
                    margin-bottom: 10px
                    img
                        width: 41px
                
            .price-text
                font-weight: 300
                span
                    color: $green
                    display: inline-block
            .share-links
                margin-bottom: 30px
                @media (max-width: 991px)
                    //display: none
                a
                    margin-right: 20px
            
            .photo-slide
                padding: 0 30px
                padding-bottom: 30px
                .slider-nav
                    .slick-track
                        margin-left: 0
                    .img-wrap
                        cursor: pointer
                        position: relative
                        //width: 100%
                        //padding-bottom: 33%
                        //overflow: hidden
                        img
                            width: 100%
                            border: 1px solid rgba(black, 0.1)
                            background-size: cover
                            //position: absolute
                            background-position: center center
                            height: 100%
                            //margin: 10px
                            transform: scale(0.88)
                            transform-origin: center center
                            &:hover
                                border: 1px solid $green 
                        .play-btn
                            position: absolute
                            width: 50px
                            height: 50px
                            top: 50%
                            left: 50%
                            transform: translate(-50%, -50%)
                            pointer-events: none

                .slick-next, .slick-prev
                    background-repeat: no-repeat
                    background-size: 90%
                    width: 20px
                    opacity: 0.4
                .slick-next
                    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMycHgiIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDI5Mi4zNTkgMjkyLjM1OSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjkyLjM1OSAyOTIuMzU5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIyMi45NzksMTMzLjMzMUw5NS4wNzMsNS40MjRDOTEuNDU2LDEuODA3LDg3LjE3OCwwLDgyLjIyNiwwYy00Ljk1MiwwLTkuMjMzLDEuODA3LTEyLjg1LDUuNDI0ICAgYy0zLjYxNywzLjYxNy01LjQyNCw3Ljg5OC01LjQyNCwxMi44NDd2MjU1LjgxM2MwLDQuOTQ4LDEuODA3LDkuMjMyLDUuNDI0LDEyLjg0N2MzLjYyMSwzLjYxNyw3LjkwMiw1LjQyOCwxMi44NSw1LjQyOCAgIGM0Ljk0OSwwLDkuMjMtMS44MTEsMTIuODQ3LTUuNDI4bDEyNy45MDYtMTI3LjkwN2MzLjYxNC0zLjYxMyw1LjQyOC03Ljg5Nyw1LjQyOC0xMi44NDcgICBDMjI4LjQwNywxNDEuMjI5LDIyNi41OTQsMTM2Ljk0OCwyMjIuOTc5LDEzMy4zMzF6IiBmaWxsPSIjMDAwMDAwIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==)
                .slick-prev
                    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjMycHgiIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDI5Mi4zNTkgMjkyLjM1OSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjkyLjM1OSAyOTIuMzU5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIyMi45NzksNS40MjRDMjE5LjM2NCwxLjgwNywyMTUuMDgsMCwyMTAuMTMyLDBjLTQuOTQ5LDAtOS4yMzMsMS44MDctMTIuODQ4LDUuNDI0TDY5LjM3OCwxMzMuMzMxICAgYy0zLjYxNSwzLjYxNy01LjQyNCw3Ljg5OC01LjQyNCwxMi44NDdjMCw0Ljk0OSwxLjgwOSw5LjIzMyw1LjQyNCwxMi44NDdsMTI3LjkwNiwxMjcuOTA3YzMuNjE0LDMuNjE3LDcuODk4LDUuNDI4LDEyLjg0OCw1LjQyOCAgIGM0Ljk0OCwwLDkuMjMyLTEuODExLDEyLjg0Ny01LjQyOGMzLjYxNy0zLjYxNCw1LjQyNy03Ljg5OCw1LjQyNy0xMi44NDdWMTguMjcxQzIyOC40MDUsMTMuMzIyLDIyNi41OTYsOS4wNDIsMjIyLjk3OSw1LjQyNHoiIGZpbGw9IiMwMDAwMDAiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K)
                .slick-prev::before
                    color: transparent
                .slick-next::before
                    color: transparent
                .slick-prev 
                    left: -15px
                .slick-next
                    right: -20px 
            .p-content
                font-weight: 400
                line-height: 26px
                text-align: justify
                margin-bottom: 30px
                @media (max-width: 576px)
                    font-weight: 300
                
    .slider-for-outer
        display: flex
        justify-content: center
        align-items: center
        padding: 30px
        .slider-for
            width: 100%
            // dispaly: flex
            // justify-content: center
            // align-items: center
            .img-wrap
                a
                    display: block
                    height: 100%
                    outline: none
                    
                    
                    .video-wrap
                        padding-bottom: 56.25%
                        position: relative
                        width: 100%

                        //height: 100%
                        iframe
                            position: absolute
                            width: 100%
                            height: 100%
                            top: 50%
                            left: 50%
                            transform: translate(-50%, -50%)
                    img
                        width: 100%
                        margin: 0 auto
                        display: block
                .video-class
                    width: 100%
                    display: flex
                    align-items: center
            .slick-track
                display: flex
                .slick-slide
                    display: flex
                    justify-content: center
                    align-items: center
                    height: auto
                    > div
                        width: 100%
    .share-links-m
        display: none
        text-align: center
        a
            display: inline-block
            width: 80px
            margin: 0 10px
            img
                width: 100%
        @media (max-width: 991px)
            display: block


.slick-lightbox-slick-item-inner
    img
        transform: scale(1.2)
        transform-origin: center center
        @media (max-width: 768px)
            transform: scale(1)



//========inner========
#product-intro.product-intro.product-inner
    margin-top: 100px
    margin-bottom: 80px
    @media (max-width: 991px)
        margin-top: 80px
        margin-bottom: 70px
    @media (max-width: 576px)
        margin-top: 50px
        padding: 50px 15px
        margin-bottom: 0
    @media (max-width: 450px)
        margin-top: 0
    .title-wrap
        border-radius: 20px 20px 0 0
        
    .p-name
        font-size: 24px
        transform: none
        background: white
        text-align: left
        margin: 0 auto
        position: relative
        padding: 0
        width: 100%
        padding-bottom: 30px
        @media (max-width: 768px)
            padding-top: 30px
        @media (max-width: 576px)
            padding-top: 40px
        span
            font-size: 18px
            display: block
            transform: none
            position: static

    .bg
        // background-image: url('../assets/product-bg.png')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center center
        transform: translateZ(0)
        will-change: transform
        z-index: -1001
        
    
    .pd-container
        position: relative
        &:before
            content: ''
            position: absolute
            //display: none
            width: 100%
            height: 100%
            top: 0
            left: 0
            background: white
            //box-shadow: 0 1px 10px rgba(black, 0.1)
            border-radius: 20px
            @media (max-width: 991px)
                display: block
                box-shadow: 0 1px 10px rgba(black, 0.1)
                opacity: 1

    .pd-row
        position: relative
        margin-right: -15px
        margin-left: -15px
        padding-left: 0
        padding-right: 0
        background: white
        padding-top: 30px
        padding-bottom: 60px
        border-radius: 20px
        margin-top: 0
        @media (max-width: 991px)
            padding-left: 30px
            padding-right: 30px
        @media (max-width: 768px)
            padding-top: 0px
            padding-bottom: 100px
        @media (max-width: 576px)
            padding-bottom: 50px
            padding-left: 0px
            padding-right: 0px
        .col-12.col-lg-6
            padding-right: 15px
            padding-left: 15px
            margin-bottom: 0
        &:last-child
            &:before
                display: none
        
    .content-wrap-outer
        height: 100%
        display: flex
        align-items: center
        justify-content: center
        padding: 15px
        border: none
        @media (max-width: 576px)
            padding: 0
        .content-wrap
            width: 100%
            @media (max-width: 991px)
                font-size: 18px
            @media (max-width: 768px)
                font-size: 16px
            .logo-wrap
                margin-bottom: 10px
                img
                    width: 30%
                    min-width: 150px
                @media (max-width: 991px)
                    text-align: left
            .share-links
                a
                    display: inline-block
                    width: 80px
                    img
                        width: 100%

            .line1
                margin-bottom: 20px
                @media (max-width: 576px)
                    display: flex
                div
                    display: inline-block
                    white-space: nowrap
                    span
                        padding: 8px 10px
                        display: inline-block
                        background: black
                        border-radius: 5px
                        margin-right: 5px
                        color: white
                        @media (max-width: 576px)
                            padding: 6px 8px
                

                .text1
                    margin-right: 20px
                    @media (max-width: 576px)
                        margin-right: 5px
                .text1,.text2
                    cursor: pointer
                    transition: .3s
                    span
                        font-size: 20px
                    @media (max-width: 350px)
                        font-size: 14px
                        letter-spacing: 0px
                    &:hover
                        color: $darkGreen 
                        span
                            transition: .3s
                            background: $green
                
            .line2
                color: #0f2a85
                margin-bottom: 10px
                display: flex
                //justify-content: center
                align-items: center
                @media (max-width: 991px)
                    span > span 
                        display: block
                .s-logo
                    display: inline-block
                    //width: 40px
                    vertical-align: middle
                    margin-right: 5px
                    //padding-bottom: 56.25%
                    //border: 1px solid
                    width: 12%
                    max-width: 40px
                    @media (max-width: 576px)
                        height: 40px
                        min-width: 60px
                        position: relative
                        //left: -8px


                    svg
                span
                    display: inline-block
                        //width: 
            .award-line
                margin-bottom: 15px
                .aw1
                    img
                        width: 150px
                .aw2
                    margin-bottom: 10px
                    img
                        width: 41px
                
            .price-text
                font-weight: 300
                span
                    color: $green
                    display: inline-block
            .share-links
                margin-bottom: 20px
                @media (max-width: 991px)
                    display: none
                a
                    margin-right: 20px
            
            .photo-slide
                padding: 0
                .slider-nav
                    .slick-track
                        margin-left: 0
                    .img-wrap
                        cursor: pointer
                        position: relative
                        //width: 100%
                        //padding-bottom: 33%
                        //overflow: hidden
                        img
                            width: 100%
                            border: 1px solid rgba(black, 0.1)
                            background-size: cover
                            //position: absolute
                            background-position: center center
                            height: 100%
                            //margin: 10px
                            transform: scale(0.88)
                            transform-origin: center center
                            &:hover
                                border: 1px solid $green
                        .play-btn
                            position: absolute
                            width: 50px
                            height: 50px
                            top: 50%
                            left: 50%
                            transform: translate(-50%, -50%)
                            pointer-events: none

                .slick-next::before
                    color: rgba(black, 0.5)
                    font-family: "Font Awesome 5 Free"
                    font-weight: 900
                    content: "\f0da"
                    font-size: 25px
                .slick-prev::before
                    color: rgba(black, 0.5)
                    font-family: "Font Awesome 5 Free"
                    font-weight: 900
                    content: "\f0d9"
                    font-size: 25px
                .slick-prev 
                    left: -12px
                .slick-next
                    right: -20px 
            .p-content
                font-weight: 400
                text-align: justify
                @media (max-width: 576px)
                    font-weight: 300
                
    .slider-for-outer
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        padding: 15px
        .slider-for
            width: 100%
            // dispaly: flex
            // justify-content: center
            // align-items: center
            .img-wrap
                a
                    display: block
                    height: 100%
                    outline: none
                    
                    
                    .video-wrap
                        padding-bottom: 56.25%
                        position: relative
                        width: 100%

                        //height: 100%
                        iframe
                            position: absolute
                            width: 100%
                            height: 100%
                            top: 50%
                            left: 50%
                            transform: translate(-50%, -50%)
                    img
                        width: 100%
                        margin: 0 auto
                        display: block
                .video-class
                    width: 100%
                    display: flex
                    align-items: center
            .slick-track
                display: flex
                .slick-slide
                    display: flex
                    justify-content: center
                    align-items: center
                    height: auto
                    > div
                        width: 100%
    .share-links-m
        display: none
        text-align: center
        a
            display: inline-block
            width: 80px
            margin: 0 10px
            img
                width: 100%
        @media (max-width: 991px)
            display: block


.slick-lightbox-slick-item-inner
    img
        transform: scale(1.2)
        transform-origin: center center
        @media (max-width: 768px)
            transform: scale(1)
</style>




// WEBPACK FOOTER //
// src/Index/ProductIntro.vue